module.exports = __webpack_public_path__ + "img/star.6378f7d2.svg";